// extracted by mini-css-extract-plugin
module.exports = {"container":"_5b10bb2305--container--i5GK0","aside":"_5b10bb2305--aside--qIRjU","close":"_5b10bb2305--close--Cs24z"};